<template>
  <div>
    <packageTable
      ref="contentBaseRef"
      class="contentBaseRef"
      :columnsData="columnsheader"
      :tableData="tableDataList"
      :reduceheight="reduceheight"
      :loading="tableLoading"
      :border="true"
      :tabletotallen="getPageTotal"
      :showSearchBtn="false"
      :tablePageSize="reqBase.page_size"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @refreshBtn="init"
      @getSelect="getSelectList"
    >
      <template slot="search">
        <Form
          ref="formInline"
          :model="form_filter"
          class="tableHeaderForm"
          @keydown.enter.native="search"
          inline
        >
          <FormItem>
            <Select
              v-model="form_filter.xieyi_type"
              transfer
              :placeholder="this.$t('请选择协议配置')"
            >
              <Option
                v-for="item in xieyiData"
                :value="item.value"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
          <FormItem>
            <Select
              v-model="form_filter.product_type_code"
              transfer
              :placeholder="this.$t('请选择产品名称')"
            >
              <Option
                v-for="item in product_type_codeData"
                :value="item.product_type_code"
                :key="item.product_type_code"
                >{{$t(item.product_name)}}</Option
              >
            </Select>
          </FormItem>

          <FormItem>
            <Input
              type="text"
              v-model="form_filter.project_code"
              :placeholder="this.$t('请输入产品项目号')"
            />
          </FormItem>
          <FormItem class="reduceFromMarginLeft">
            <Button
              v-for="(item, index) in topButtonList"
              :type="item.type"
              style="margin-right: 5px"
              @click="item.method"
              :key="index"
              >{{ item.name }}</Button
            >
          </FormItem>
        </Form>
      </template>
      <template slot="headRight">
        <!-- <Tooltip v-for="(item,index) in topButtonList1" :key="index"  :content="item.name" placement="bottom">
                <Button  
                    :type="item.type"      
                    style="margin-right: 5px;" 
                    @click="item.method" 
                    :key="index" 
                    :icon="item.icon"></Button>
            </Tooltip> -->
      </template>
      <template slot="headRight">
        <Tooltip
          v-for="(item, index) in topButtonList1"
          :key="index"
          :content="item.name"
          placement="bottom"
        >
          <Button
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
            :icon="item.icon"
          ></Button>
        </Tooltip>
      </template>
    </packageTable>
  </div>
</template>
<script>
import packageTableMixins from "@/mixins/packageTableMixins";
import customDetails from "./components/customDetails.vue";
import uploadCom from "./components/uploadCom";
import addCom from "./components/addCom";
import passCom from "./components/passCom";
import config from "@/config/index";

import {
  product_list,
  set_default,
  product_add,
  dict_update,
  product_del,
  daoru,
  daochu,
  get_type,
  get_downloadtoken,
  config_pass,
} from "@/api/jingxiaoshang";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    return {
      pass_priv: 1,
      xieyiData: [
        { value: -1, name: this.$t("全部") },
        { value: 1, name: this.$t("默认") },
        { value: 2, name: this.$t("自定义") },
      ],
      xieyi_codeData: [],
      product_type_codeData: [],
      model_codeData: [],
      country_codeData: [
        { value: "xciot-prod-cnsz", name: "中国区" },
        { value: "xciot-prod-hk", name: "香港区" },
        { value: "xciot-prod-eu", name: "欧洲区" },
        { value: "xciot-prod-us2", name: "美国区" },
      ],
      country_code2Data: [{ value: "86", name: "中国" }],
      form_filter: {
        xieyi_type: "",
        product_type_code: "",
        project_code: "",
      },
      //共用的查询与重置
      topButtonList: [
        {
          name: this.$t('query'),
          type: "primary",
          method: this.search,
        },
        {
          name: this.$t('reset'),
          type: "error",
          method: this.reset,
        },
      ],
      //共用的右侧添加按钮
      topButtonList1: [
        {
          name: this.$t("add"),
          icon: "ios-add",
          type: "primary",
          method: this.add,
        },
        // {
        //       name:this.$t('import'),
        //       icon:'ios-cloud-upload',
        //       type:'primary',
        //       method:this.daoru
        //     },
        //    {
        //       name:this.$t('export'),
        //       icon:'ios-cloud-download',
        //       type:'primary',
        //       method:this.daochu
        //     },

        // {
        //   name:this.$t('refresh'),
        //   icon:'ios-refresh',
        //   type:'primary',
        //   method:this.init
        // }
      ],
      reqBase: {
        page: 1,
        page_size: 15,
        product_type_code: this.$route.query.product_type_code,
        hardware_ver: this.$route.query.hardware_ver,
      },
      status: true, //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [
        {
          name: this.$t("delete"),
          type: "primary",
          icon: "",
          method: this.del,
        },
        {
          name:this.$t("devicelist.passman"),
          type: "primary",
          icon: "",
          method: this.configpass,
        },
      ],
      customButtonList: [
        {
          name: this.$t("自定义")+'>',
          type: "text",
          icon: "",
          method: this.custom,
        },
      ],

      // operationButtonList1:[
      //   {
      //     name:this.$t('operationModule.submitReview'),
      //     type:'primary',
      //     icon:'',
      //     method:this.submitReview
      //   },
      // ],
      columnsheader: [
        // {
        //   align: 'center',
        //   title: '序号',//this.$t('dictmenu.protocoltype')
        //   key: 'id',
        // },
        {
          align: "center",
          title:this.$t("产品项目号"),
          key: "project_code",
        },
        {
          align: "center",
          title: this.$t("产品名称"),
          key: "product_name",
        },
        {
          align: "center",
          title: this.$t("devicelist.hardwareversionnumber"),
          key: "hardware_ver",
        },
        {
          align: "center",
         title:this.$t("产品型号"),
          key: "model_code",
        },
        // {
        //   align: 'center',
        //   title: '联网方式',
        //   key: 'connect_type',
        //   render:(h,{row})=>{
        //         let result = '';

        //        if (row.connect_type == 1) {
        //           result="WiFi"
        //        } else if(row.connect_type == 2) {
        //           result="4G"
        //        }else{
        //         result=""
        //        }
        //         return h('div',result)

        //   }
        // },
        {
          align: "center",
          title:this.$t("协议配置"),

          key: "xieyi_type",
          render: (h, { row }) => {
            if (row.xieyi_type == 1) {
              let result = "";
              result = this.$t("默认");
              return h("div", result);
            } else if (row.xieyi_type == 2) {
              let arr = [];
              let list = this.customButtonList[0];

              arr.push(
                h(
                  "Button",
                  {
                    style: {
                      marginLeft: "5px",
                      marginBottom: "3px",
                      color: "#3253fa",
                    },
                    props: {
                      type: list.type,
                      size: list.size ? list.size : "small",
                    },
                    on: {
                      click: () => {
                        this.custom(row);
                      },
                    },
                  },
                  list.name
                )
              );
              return h("div", { style: { padding: "5px" } }, arr);
            } else {
              result = "";
              return h("div", result);
            }
          },
        },
        {
          align: "center",
          title: this.$t("dictmenu.creationtime"),
          key: "addtime",
        },
        {
          align: "center",
          title:this.$t("handleuser"),
          key: "admin_name",
        },

        {
          align: "center",
          title: this.$t("operation"),
          minWidth: 80,
          key: "Operating",
          render: (h, { row }) => {
            let arr = [];
            //this.operationButtonList = [];
            let list = this.operationButtonList[0];
            arr.push(
              h(
                "Button",
                {
                  style: { marginLeft: "5px", marginBottom: "3px" },
                  props: {
                    type: list.type,
                    size: list.size ? list.size : "small",
                  },
                  on: {
                    click: () => {
                      this.del(row);
                    },
                  },
                },
                list.name
              )
            );
            if (this.pass_priv == 1) {
              list = this.operationButtonList[1];
              arr.push(
                h(
                  "Button",
                  {
                    style: { marginLeft: "5px", marginBottom: "3px" },
                    props: {
                      type: list.type,
                      size: list.size ? list.size : "small",
                    },
                    on: {
                      click: () => {
                        this.configpass(row);
                      },
                    },
                  },
                  list.name
                )
              );
            }
            return h("div", { style: { padding: "5px" } }, arr);
            // return h('div',arr)
          },
        },
      ],
    };
  },
  props: {
    reducehe: {},
    code: {},
  },
  components: {
    customDetails,
  },
  computed: {},
  methods: {
    custom(row) {
      const routeData = this.$router.push({
        path: "/protocolman/projectprotocollist",
        query: {
          product_code: row.product_code,
          project_code: row.project_code,
          xieyi_code: row.xieyi_code,
        },
      });
      window.open(routeData.href, "_self");
    },
    get_type() {
      get_type({}).then((res) => {
        let msg = res.errorMsg;
        if (res.result === 0) {
          let msg = res.errorMsg;
          this.product_type_codeData = res.body.product_type;
          this.xieyi_codeData = res.body.xieyi_codeData;
          this.model_codeData = res.body.model_codeData;
          console.log("111", this.xieyi_codeData);
          //this.inverter_typeData=res.body.inverter_type
        } else {
          vm.$Message.error(msg);
          _this.buttonLoading = false;
        }
      });
    },
    /**
     * 导入
     */
    daoru() {
      let vm = this;
      let config = {
        loading: true,
        width: 600,
        render: (h) => {
          return h("div", [
            h("h3", this.$t("import")),
            h(uploadCom, {
              ref: "uploadCom",
              props: {
                edit: false,
                _vm: vm,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.uploadCom;
          obj.checkForm().then((res) => {
            if (res) {
              //提交请求
              let formModel = obj.formModel;
              let formData = new FormData();
              formData.append("filename", formModel.filename);
              daoru(formData).then((res) => {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg, 5);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    daochu() {
      let vm = this;
      let config = {
        title: this.$t("export"),
        loading: true,
        content: this.$t("dictmenu.sureexport"),
        onOk: function () {
          let _this = this;
          // vm.$store.dispatch("user/handleget_downloadtoken", { type: "did" })
          //   .then((res) => {

          get_downloadtoken().then((res) => {
            // console.log(res.result)
            //     return
            _this.buttonLoading = false;
            if (res.result === 0) {
              let downloadtoken = res.body.downloadtoken;
              let params = "?type=1&downloadtoken=" + downloadtoken;

              window.open(
                "http://pcphp.test.xcthings.com/index.php/admin/dict/daochu" +
                  params
              );
              vm.$Modal.remove();
            } else {
              vm.$Message.error(res.errorMsg);
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },

    /**
     * 删除
     */
    del(row) {
      let vm = this;
      this.$Modal.confirm({
          title:this.$t('删除') ,
        content:this.$t('您确定要删除')+row.project_code+'?',
        loading: true,
        onOk: function () {
          let _this = this;
          product_del({ product_code: row.product_code }).then((res) => {
            let msg = res.errorMsg;
            if (res.result === 0) {
              let msg = res.errorMsg;
              vm.$Message.success(msg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        },
      });
    },
    details(row) {
      let vm = this;
      let config = {
        okText: "关闭",
        loading: true,
        width: 600,
        render: (h) => {
          return h("div", [
            h("h3", this.$t("viewdetails")),
            h(addCom, {
              ref: "addCom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                hasDetails: true,
                setData: row,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          this.$Modal.remove();
        },
      };
      this.$Modal.success(config);
    },
    configpass(row) {
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                 this.$t("Changelang.密码管理")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(passCom, {
              ref: "passCom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: true,
                parent_code: "0",
                parent_name: "无",
                product_type_codeData: vm.product_type_codeData,
                setData: row,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.passCom;
          obj.checkForm().then((res) => {
            // console.log("req", {...obj.formModel})
            // return;
            if (res) {
              config_pass({ ...obj.formModel }).then((res) => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    getUser() {
      return this.$store.state.user.userInfo;
    },

    add() {
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                 this.$t("新建产品（产品模型）"),
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(addCom, {
              ref: "addCom",
              props: {
                _vm: vm,
                $store: vm.$store,
                edit: false,
                parent_code: "0",
                parent_name: "无",
                product_type_codeData: vm.product_type_codeData,
                xieyi_codeData: vm.xieyi_codeData,
                product_type_code: vm.$route.query.product_type_code,
                hardware_ver: vm.$route.query.hardware_ver,
                model_codeData: vm.model_codeData,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addCom;
          obj.checkForm().then((res) => {
            // console.log("req", obj)
            // return;
            if (res) {
              product_add({ ...obj.formModel }).then((res) => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },
    edit(row) {
      console.log("a", row);
      let vm = this;
      let config = {
        loading: true,
        width: 500,
        render: (h) => {
          return h("div", [
            h(
              "div",
              { style: { display: "flex", justifyContent: "space-between" } },
              [
                h(
                  "h3",
                  { style: { width: "100%", paddingBottom: "5px" } },
                  this.$t("dictmenu.editiverterdict")
                ),
                h("icon", {
                  props: { type: "md-close", size: "16" },
                  style: {
                    cursor: "pointer",
                  },
                  on: {
                    click: (evt) => {
                      vm.$Modal.remove();
                    },
                  },
                }),
              ]
            ),
            h("Divider", {
              style: {
                margin: "8px 0",
              },
            }),
            h(addCom, {
              ref: "addCom",
              props: {
                edit: true,
                $store: vm.$store,
                _vm: vm,
                setData: row,
                product_type_codeData: vm.product_type_codeData,
                xieyi_codeData: vm.xieyi_codeData,
              },
            }),
          ]);
        },
        onOk: function () {
          let _this = this;
          let obj = this.$refs.addCom;
          obj.checkForm().then((res) => {
            if (res) {
              //let { area_name, desc, area_code } = obj.formModel

              dict_update(obj.formModel).then((res) => {
                let msg = res.errorMsg;
                if (res.result === 0) {
                  let msg = res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        },
      };
      this.$Modal.confirm(config);
    },

    set_default(row) {
      // console.log(row)
      let vm = this;
      this.$Modal.confirm({
        title: "设为默认",
        content: "您确定要设置" + row.protocol_name + "为默认吗？",
        loading: true,
        onOk: function () {
          let _this = this;
          set_default({ dict_code: row.dict_code }).then((res) => {
            let msg = res.errorMsg;
            if (res.result === 0) {
              let msg = res.errorMsg;
              vm.$Message.success(msg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        },
      });
    },

    init() {
      let userinfo = this.getUser();
      this.pass_priv = userinfo.pass_priv;
      this.get_type();
      this.tableLoading = true;
      product_list({ ...this.reqBase }).then((res) => {
        this.tableLoading = false;
        this.tableDataList = [];
        if (res.result === 0) {
          this.tableDataList = res.body.list || [];
          this.getPageTotal = res.body.total;
        } else {
          this.tableDataList = [];
          this.getPageTotal = 0;
          this.$Message.error(res.errorMsg);
        }
      });
    },

    search() {
      this.onSearch(this.form_filter);
    },
    reset() {
      this.form_filter = {
        xieyi_type: null,
        product_type_code: null,
        project_code: null,
      };
      this.search();
    },
  },

  mounted() {
    if (this.code) {
      this.$set(this.reqBase, "project_code", this.code);
    }
    if (this.reducehe) {
      this.reduceheight = this.reducehe;
    } else {
      this.init();
    }
  },
  created() {
    // this.getPageSizeToStorage();
  },
};
</script>
<style scoped>
.div2 {
  font-size: 15px;
  text-align: center;
}
.contentBaseRef /deep/ .headerWrapper {
  align-items: center;
}
</style>
